import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Alert,
  Button,
  Space,
  Drawer,
  Card,
  Input,
  message as messageApi,
} from "antd";
import { api } from "../../../config/api";
import { useDispatch } from "react-redux";
import { getAuthToken } from "../../../helpers/account";
import { requiresConfirmationOfRefusedItemsSent } from "../../../helpers/actions";

const ConfirmRefusedItemsSentAction = (props) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [trackingNumber, setTrackingNumber] = useState("");
  const [trackingNumberConfirmation, setTrackingNumberConfirmation] =
    useState("");
  const [loading, setLoading] = useState(false); // Added loading state
  const dispatch = useDispatch();
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleConfirmation = () => {
    setLoading(true);

    // Check if tracking numbers match
    if (trackingNumber !== trackingNumberConfirmation) {
      messageApi.open({
        type: "error",
        content: t('transaction.actions.trackingNumberMismatch'),
      });
      setLoading(false);
      return;
    }

    if (trackingNumber === "") {
      messageApi.open({
        type: "error",
        content: t('transaction.actions.trackingNumberRequired'),
      });
      setLoading(false);
      return;
    }    

    // Your API endpoint URL goes here
    const apiUrl = `${api.host}/transactions/${props.transaction.uuid}`;
    const jsonData = {
      inspection_items_refused_sent: true,
      inspection_items_refused_shipping_tracking_code: trackingNumber,
    };

    // Fetch data from the API
    fetch(apiUrl, {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `${getAuthToken()}`,
      }),
      body: JSON.stringify(jsonData),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response data
        messageApi.open({
          type: "success",
          content: t('transaction.actions.confirmationSaved'),
        });
        setTimeout(() => {
          dispatch({
            type: "transactionDataUpdated",
            payload: {
              transactionDataChanged: new Date().getSeconds(),
            },
          });
          setLoading(false);
        }, 2000); // Delay for 2 seconds
      })
      .catch((error) => {
        messageApi.open({
          type: "error",
          content: t('transaction.actions.transactionSaveError'),
        });
        setLoading(false);
      });
  };

  let canBeRendered = false;

  if (requiresConfirmationOfRefusedItemsSent(props.transaction)) {
    canBeRendered = true;
  }

  if (canBeRendered === true) {
    return (
      <>
        <Drawer
          title={t('transaction.actions.confirmItemShipment')}
          placement="right"
          onClose={onClose}
          open={open}
        >
          <Card
            title={t('transaction.actions.trackingNumber')}
            style={{
              width: 300,
            }}
          >
            <Space direction="vertical">
              <div>
                <Input
                  required={true}
                  size="large"
                  placeholder={t('transaction.actions.carrierNumber')}
                  autoComplete="off"
                  value={trackingNumber}
                  onChange={(e) => setTrackingNumber(e.target.value)}
                />
              </div>
              <div>
                <Input
                  required={true}
                  size="large"
                  placeholder={t('transaction.actions.confirmCarrierNumber')}
                  autoComplete="off"
                  value={trackingNumberConfirmation}
                  onChange={(e) =>
                    setTrackingNumberConfirmation(e.target.value)
                  }
                />
              </div>
              <Button type="primary" onClick={handleConfirmation} loading={loading}>
                {t('transaction.actions.save')}
              </Button>
            </Space>
          </Card>
        </Drawer>
        <Alert
          type="warning"
          message={t('transaction.actions.returnContractItem')}
          description={t('transaction.actions.returnByDate')}
          action={
            <Space direction="vertical">
              <Button type="primary" onClick={showDrawer}>
                {t('transaction.actions.confirmReturn')}
              </Button>
            </Space>
          }
        />
      </>
    );
  }
};

export default ConfirmRefusedItemsSentAction;
